import { Skeleton } from '@shared/components/ui/skeleton';
import { cn } from '@shared/lib/utils';

interface SkeletonCardGridProps {
  cards?: number;
  className?: string;
}

/**
 * Skeleton placeholder for card-grid loading states (e.g. Agents page).
 */
export function SkeletonCardGrid({ cards = 6, className }: SkeletonCardGridProps) {
  return (
    <div className={cn('grid gap-4 sm:grid-cols-2 xl:grid-cols-3', className)}>
      {Array.from({ length: cards }).map((_, i) => (
        <div
          key={i}
          className="flex flex-col overflow-hidden rounded-xl border bg-card shadow-sm"
        >
          {/* Color strip */}
          <Skeleton className="h-1 w-full rounded-none" />

          {/* Header */}
          <div className="px-5 pt-4 pb-3 space-y-3">
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-3">
                <Skeleton className="h-10 w-10 rounded-xl shrink-0" />
                <div className="space-y-1.5">
                  <Skeleton className="h-4 w-32 rounded" />
                  <Skeleton className="h-3 w-20 rounded" />
                </div>
              </div>
              <Skeleton className="h-8 w-8 rounded shrink-0" />
            </div>
            <div className="flex gap-2 mt-1">
              <Skeleton className="h-5 w-16 rounded-full" />
              <Skeleton className="h-5 w-24 rounded-full" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 px-5 pb-3 space-y-2">
            <Skeleton className="h-3 w-full rounded" />
            <Skeleton className="h-3 w-4/5 rounded" />
            <div className="mt-2 rounded-lg border bg-muted/50 p-3 space-y-1.5">
              <Skeleton className="h-2.5 w-20 rounded" />
              <Skeleton className="h-3 w-full rounded" />
              <Skeleton className="h-3 w-3/4 rounded" />
            </div>
          </div>

          {/* Footer */}
          <div className="border-t bg-muted/20 px-4 py-3 flex items-center justify-between">
            <Skeleton className="h-3.5 w-24 rounded" />
            <div className="flex gap-3">
              <Skeleton className="h-3.5 w-8 rounded" />
              <Skeleton className="h-3.5 w-8 rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
